import { render, staticRenderFns } from "./ViewPayslip.vue?vue&type=template&id=4d57ccb7&scoped=true"
import script from "./ViewPayslip.vue?vue&type=script&lang=js"
export * from "./ViewPayslip.vue?vue&type=script&lang=js"
import style0 from "./ViewPayslip.vue?vue&type=style&index=0&id=4d57ccb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57ccb7",
  null
  
)

export default component.exports